import {
  dateTimeFormatter,
  eventFormatter,
  readableEventDescription,
} from '../../utils/formatters';

export const userActionLogColumns = [
  {
    dataField: 'created_at',
    text: 'Дата и время',
    disableSort: true,
    dataClassName: 'align-middle',
    formatter: date => dateTimeFormatter(date),
    toCopyFormatter: dateTimeFormatter,
    headerClassName: 'date-time-column',
    hidden: false,
  },
  {
    dataField: 'user_name',
    text: 'Пользователь',
    disableSort: true,
    dataClassName: 'align-middle',
    headerClassName: 'description-column',
    hidden: false,
  },
  {
    dataField: 'description',
    text: 'Действие',
    disableSort: true,
    formatter: eventFormatter,
    toCopyFormatter: readableEventDescription,
    headerClassName: 'description-column',
    hidden: false,
  },
];

export const addUserActionLogColumns = [];
